import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, useResource, useStore, useToast, usePage } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
    BASE,
    URLS,
    APIS,
    SF_CNTY_CD_SRCH,
    SG_CNTY_CD_LIST,
} from "@/tz/go/egaz/osci/ptl/cd/cntycd/services/OsciCntyCdService";

/*
 * Country Code Management List
 * !== 국가 코드 관리 목록 ==!
 */
export const OSCI0109009Q = (props: any) => {
    useResource({
        defaultSchema: [{ area: "cntyCd" }, { area: "comnCd", comnCd: "OSC0091" }],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();

    const form = {
        cntyCdSrch: useForm({
            defaultSchema: SF_CNTY_CD_SRCH,
            defaultValues: { ...pgeStore?.form },
        }),
    };

    const grid = {
        cntyCdList: useGrid({
            defaultSchema: SG_CNTY_CD_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // Retrieve a list of country codes. !== 국가코드 목록을 조회한다.==!
        getCntyCdList: useFetch({
            api: (page = grid.cntyCdList.page) =>
                APIS.getCntyCdList(form.cntyCdSrch.getValues(), page, grid.cntyCdList.size),
            enabled: comnUtils.isEmpty(form.cntyCdSrch.errors),
            key: [grid.cntyCdList.page, grid.cntyCdList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.cntyCdSrch.getValues(),
                    page: grid.cntyCdList.page,
                    size: grid.cntyCdList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        cell: {
            cntyCd: (props: any) => {
                const { rowValues, value } = props;
                return <Link to={`${URLS.osci0109011s}/${rowValues.cntyCd}`}>{value}</Link>;
            },
        },
    };

    const handler = {
        getCntyCdList: () => {
            grid.cntyCdList.setPage(0);
            fetch.getCntyCdList.fetch(0);
        },
        initData: () => {
            form.cntyCdSrch.reset();
            form.cntyCdSrch.setValue("code", "");
        },
    };

    useEffect(() => {
        handler.getCntyCdList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cntyCdSrch.schema.cntyCd} />
                            <Group.Control {...form.cntyCdSrch.schema.cntyNm} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.cntyCdSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.getCntyCdList} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.cntyCdList.grid} data={fetch.getCntyCdList.data?.cntyCdList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout.Left>
                <Button
                    role={"new"}
                    onClick={() => {
                        navigate(`${URLS.osci0109010s}?menuId=${menuId}`);
                    }}
                />
            </Layout.Left>
        </Page>
    );
};
